import { render, staticRenderFns } from "./ProgramaAssinatura.vue?vue&type=template&id=442c297e&"
import script from "./ProgramaAssinatura.vue?vue&type=script&lang=js&"
export * from "./ProgramaAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports